
export default function ReviewsSection() {
  const reviews = [
    {
      name: 'Simon W',
      date: '19-08-2019',
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F28a9907e9ea649fda3ec999515256367&methods=resize%2C600%2C5000',
      text: 'Daniel and Tony get an easy five stars. In fact it would be more if that was allowed. They are simply the best, most careful, thoughtful, and pleasant craftsmen that you could wish for. In the thirty-five years that we\'ve owned our house in Watford, no-one has come close to matching them. Nothing is too much trouble; they work extremely neatly and cleanly; and they take great pride in their work. They are also extremely nice people to have around. We recommend them without hesitation.',
    },
    {
      name: 'Anne-Renee',
      date: '19-08-2021',
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F3d337e49ebfe42d9a8904050fc6dcf5c&methods=resize%2C600%2C5000',
      text: 'Daniel has just finished working in my house for the third time. As usual, the standard of his decorating is excellent. No job is too small for Daniel, and with his pleasant manner he is a joy to have in the house. He is totally trustworthy, and at the end of each day the house is always left clean and tidy. I have no hesitation whatsoever in recommending him to anyone in need of a decorator. Thank you Daniel for another brilliant job.',
    },
  ];

  return (
    <section className="py-20 px-6 bg-beige-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-wider uppercase text-amber-600 mb-3">
            Testimonials
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-base text-neutral-500 max-w-2xl mx-auto">
            Real feedback from homeowners across Watford and Hertfordshire who trusted us with their properties
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-8 border border-beige-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-amber-200">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-800">{review.name}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex gap-1 text-amber-500">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="fas fa-star text-sm"></i>
                      ))}
                    </div>
                    <span className="text-xs text-gray-500">{review.date}</span>
                  </div>
                </div>
              </div>
              <hr className="mb-6 border-beige-200" />
              <p className="text-sm text-gray-600 leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
